import axios from 'axios';
import { setHeader } from './services_general.js';

export function getHomeData() {
  return axios.get(process.env.REACT_APP_API_URL + 'api/home', { headers: setHeader() });
}
